export default __webpack_public_path__ + "static/Apeswap-5c54e74a56a7cddceeadd99bf5e2ffa8.svg";